/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import GetAppDialog from "components/dialogs/GetAppDialog";
import { inject } from "mobx-react";
import { getShowGetAppDialog } from "selectors/appSelectors";

const mapStoreToProps = (stores, ownProps) => ({
  showGetAppDialog: getShowGetAppDialog(stores),
  setShowDialog: value => stores.appStore.setShowGetAppDialog(value),
  ...ownProps
});
const GetAppContainer = inject(mapStoreToProps)(GetAppDialog);

export default GetAppContainer;
